export enum Status {
  INTRANSIT = 'INTRANSIT',

  CANCELED = 'CANCELED',

  SCHEDULED = 'SCHEDULED',

  COMPLETED = 'COMPLETED',
}
